export function page_state() {
  var current_full_location;

  // Browser back will just have to use a full page reload
  // Unless turbo drive is on, the page reload will happen anyway
  // so adding this would turn into two requests.

  // window.addEventListener('popstate', (event) => {
  //   const advancingFrames = document.querySelectorAll('turbo-frame[data-turbo-action="advance"]');

  //   event.preventDefault()

  //   if (advancingFrames.length > 0) {
  //     advancingFrames.forEach(frame => {
  //       frame.src = window.location.href;
  //     });
  //   }
  // });

  $('body').on('click', '.doc-navigation a', function(e) {
    e.preventDefault();
  
    var url = '/admin/help/documentation?id=' + $(this).attr("link");
    window.history.pushState(url, '', url);
    current_full_location = location.pathname + location.search;
  
    return false;
  });

  // For pagination
  window.addEventListener('pageshow', function(event) {
    const urlParams = new URLSearchParams(window.location.search);
    const pageNumber = urlParams.get('page') || '1';

    document.querySelectorAll('.pagination input[name="page"]').forEach(input => {
      input.value = pageNumber;
    });
  });
}

